/*** THE CLUB — Referral gift: GIFT-CARD-BLACK ***/
/*** Requisitos:
 * - URL puede traer ?ref=TC-<customerId>-<orderId>
 * - Guardamos en sessionStorage 'tc_ref_saved' y en cart.attributes:
 *     referral_code, inviter_customer_id
 * - Regalo (variant_id) sólo si subtotal >= 60€ y hay señal de referido
 * - Se ejecuta en páginas de la tienda (no en checkout)
 ***/

// ======= CONFIG =======
const MIN_SUBTOTAL_CENTS = 6000;                  // 60€
const GIFT_VARIANT_ID     = 52939393237322;       // GIFT-CARD-BLACK (tu variant)
const LOG_PREFIX          = '[TC Gift]';

// ======= HELPERS =======
const qs = new URLSearchParams(location.search);
const refParam = (qs.get('ref') || '').trim();

function parseInviterId(ref) {
  // "TC-24145693868362-101353" -> "24145693868362"
  const m = (ref || '').match(/^TC-(\d+)-/i);
  return m ? m[1] : '';
}

function sleep(ms){ return new Promise(r => setTimeout(r,ms)); }

async function getCart(){
  const r = await fetch('/cart.js', {credentials:'same-origin'});
  if(!r.ok) throw new Error('cart.js failed');
  return r.json();
}
async function cartUpdate(data){
  const r = await fetch('/cart/update.js', {
    method:'POST',
    headers:{'Content-Type':'application/json'},
    credentials:'same-origin',
    body: JSON.stringify(data || {})
  });
  if(!r.ok) throw new Error('cart/update failed');
  return r.json();
}
async function addGiftOnce(){
  const r = await fetch('/cart/add.js', {
    method:'POST',
    headers:{'Content-Type':'application/json'},
    credentials:'same-origin',
    body: JSON.stringify({ id: GIFT_VARIANT_ID, quantity: 1, properties: {} })
  });
  if(!r.ok) throw new Error('cart/add.js failed');
  return r.json();
}
async function changeLineQty(lineKey, qty){
  const r = await fetch('/cart/change.js', {
    method:'POST',
    headers:{'Content-Type':'application/json'},
    credentials:'same-origin',
    body: JSON.stringify({ id: lineKey, quantity: qty })
  });
  if(!r.ok) throw new Error('cart/change.js failed');
  return r.json();
}
async function removeGiftByKey(lineKey){
  return changeLineQty(lineKey, 0);
}

// ======= PERSIST REF (URL -> atributos + sesión) =======
async function persistRefIfAny(){
  try{
    if(refParam){
      const inviterId = parseInviterId(refParam);
      const attrs = { referral_code: refParam };
      if(inviterId) attrs.inviter_customer_id = inviterId;

      await cartUpdate({ attributes: attrs });
      sessionStorage.setItem('tc_ref_saved', refParam);
      console.log(LOG_PREFIX, 'ref guardado', attrs);
    }else{
      // Si NO hay ?ref en la URL, y el carrito no tiene atributos de referido,
      // limpiamos la marca de sesión para no regalar a quien no viene invitado.
      const c = await getCart();
      const hasCartRef = !!(c.attributes && (c.attributes.referral_code || c.attributes.inviter_customer_id));
      if(!hasCartRef){
        sessionStorage.removeItem('tc_ref_saved');
        // console.log(LOG_PREFIX, 'limpio ref de session (visita normal)');
      }
    }
  }catch(e){ console.warn(LOG_PREFIX, 'persistRefIfAny error', e); }
}

// ======= ELEGIBILIDAD Y AÑADIR/QUITAR =======
function hasRefSignal(cart){
  const sessRef = sessionStorage.getItem('tc_ref_saved');
  const attrRef = cart?.attributes?.referral_code || cart?.attributes?.inviter_customer_id;
  return !!(sessRef || attrRef);
}
function findGift(cart){
  return (cart.items || []).find(it => it.variant_id === GIFT_VARIANT_ID);
}
async function enforceGift(){
  try{
    // pequeña espera para dar tiempo a que el tema actualice el carrito tras clics
    await sleep(150);
    const cart = await getCart();

    const eligible = hasRefSignal(cart) && (cart.total_price >= MIN_SUBTOTAL_CENTS);
    const gift = findGift(cart);

    if(eligible){
      if(!gift){
        // añadir regalo
        await addGiftOnce();
        // normaliza cuando el drawer duplica justo después
        await sleep(150);
        const c2 = await getCart();
        const g2 = findGift(c2);
        if(g2 && g2.quantity !== 1){
          await changeLineQty(g2.key, 1);
        }
        console.log(LOG_PREFIX, 'regalo añadido');
      }else if(gift.quantity !== 1){
        await changeLineQty(gift.key, 1);
        console.log(LOG_PREFIX, 'normalizo qty a 1');
      }
    }else{
      if(gift){
        await removeGiftByKey(gift.key);
        console.log(LOG_PREFIX, 'regalo eliminado (no elegible)');
      }
    }
  }catch(e){
    console.warn(LOG_PREFIX, 'enforceGift error', e);
  }
}

// ======= OBSERVADORES (clicks y mutaciones) =======
function hookUserActions(){
  // 1) cada click potencial de “añadir/quitar” en el drawer
  document.addEventListener('click', (ev)=>{
    const el = ev.target;
    // heurística: cualquier botón +/–, remove, add-to-cart, qty, etc.
    if(!el) return;
    const t = (el.closest('button') || el).outerHTML || '';
    if(/add|cart|remove|qty|\+|\-|update/i.test(t)){
      // ejecutar una ráfaga de comprobaciones (por si el tema actualiza en 2-3 ticks)
      enforceGift();
      setTimeout(enforceGift, 250);
      setTimeout(enforceGift, 700);
    }
  });

  // 2) observador del mini-carrito (drawer) para detectar cambios de DOM
  const drawer = document.querySelector('#CartDrawer, .cart-drawer, .mini-cart, .drawer, .ajaxcart');
  if(drawer && 'MutationObserver' in window){
    const mo = new MutationObserver(()=> {
      enforceGift();
    });
    mo.observe(drawer, {childList:true, subtree:true});
  }
}

// ======= BOOT =======
(async function init(){
  await persistRefIfAny();
  hookUserActions();
  // comprobaciones iniciales por si ya hay productos en carrito
  enforceGift();
  setTimeout(enforceGift, 600);
})();